import { render, staticRenderFns } from "./resource-manage.vue?vue&type=template&id=229ab9dd&scoped=true"
import script from "./resource-manage.vue?vue&type=script&lang=js"
export * from "./resource-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ab9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229ab9dd')) {
      api.createRecord('229ab9dd', component.options)
    } else {
      api.reload('229ab9dd', component.options)
    }
    module.hot.accept("./resource-manage.vue?vue&type=template&id=229ab9dd&scoped=true", function () {
      api.rerender('229ab9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/resource/resource-manage.vue"
export default component.exports